import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Box, Section, Container, Link } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";

var removeTrailingSlashes = function removeTrailingSlashes(str) {
  return str.replace(/\/+$/, '');
};

var useIsCurrentPath = function useIsCurrentPath() {
  var _useState = useState(''),
      currentPath = _useState[0],
      setCurrentPath = _useState[1];

  var isCurrentPath = function isCurrentPath(path) {
    if (!currentPath) {
      return false;
    }

    if (path.startsWith('http')) {
      var link = document.createElement('a');
      link.href = path;
      path = link.pathname;
    }

    return removeTrailingSlashes(path) == removeTrailingSlashes(currentPath);
  };

  useEffect(function () {
    // window not available on SSR
    setCurrentPath(removeTrailingSlashes(window.location.pathname));
  }, []);
  return isCurrentPath;
};

var List = styled(Box).attrs({
  as: 'ul',
  $styles: {
    display: 'flex',
    whiteSpace: 'nowrap',
    overflowX: 'auto'
  },
  $py: [30, 23],
  $mb: [17, 25]
}).withConfig({
  displayName: "Navigator__List",
  componentId: "sc-1fzvtiu-0"
})([""]);
var ListItem = styled(Box).attrs({
  as: 'li',
  $styles: {
    ':last-child': {
      margin: 0
    }
  },
  $mr: 40
}).withConfig({
  displayName: "Navigator__ListItem",
  componentId: "sc-1fzvtiu-1"
})([""]);
var NavLink = styled(Link).attrs(function (_ref) {
  var theme = _ref.theme,
      $isActive = _ref.$isActive;
  return {
    $styles: {
      fontSize: 18,
      fontWeight: $isActive ? 700 : 400,
      lineHeight: 24,
      ':hover': {
        color: theme.colors.primaryBlueHover
      },
      ':focus': _objectSpread({}, theme.focus.outlines.withOffset)
    },
    'data-testid': $isActive ? 'navigator-active-link' : ''
  };
}).withConfig({
  displayName: "Navigator__NavLink",
  componentId: "sc-1fzvtiu-2"
})([""]);

var Navigator = function Navigator(_ref2) {
  var items = _ref2.items,
      sectionId = _ref2.sectionId;
  var isCurrentPath = useIsCurrentPath();
  return /*#__PURE__*/_jsx(Section, {
    type: "minimal",
    id: sectionId,
    children: items && /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(List, {
        children: items.map(function (item, index) {
          return /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(NavLink, {
              href: item.href,
              $isActive: isCurrentPath(item.href),
              children: item.title
            })
          }, index);
        })
      })
    })
  });
};

export default Navigator;